<script setup lang="ts">
import type { CoreResource } from './core-resource-builder'
import { computed, onMounted } from 'vue-demi'
import buildCoreResource from './core-resource-builder'
import { CF_CORE_BASE_URL } from './resource-base-urls'

interface ResourceProviderProps {
  environment: string
  core?: boolean
}

interface ResourceProviderEmits {
  (e: 'coreProvided', payload: CoreResource): void
}

const props = defineProps<ResourceProviderProps>()
const emits = defineEmits<ResourceProviderEmits>()

function toBool(value: boolean | string): boolean {
  return value === true || value === 'true'
}

const coreInstance = computed(() => {
  if (!toBool(props.core))
    return undefined

  return buildCoreResource(CF_CORE_BASE_URL[props.environment])
})

onMounted(() => {
  if (coreInstance.value)
    emits('coreProvided', coreInstance.value)
})
</script>

<template>
  <slot name="resource" />
</template>
